{
  "rating-star-icon": {
    "text": {
      "review": "recenze",
      "reviews": "recenze"
    }
  }
}
